// 根据tab确定review是否展示
import * as React from 'react';

interface propTypes {
    tabs: [string];
}

export default function Index ( props: propTypes ) {
    const { tabs } = props;
    if ( tabs.indexOf( 'discuss' ) === -1 ) return null;
    return (
        <div id="product-discuss" />
    );
}
